import type React from "react";
import {useNavigate} from "react-router-dom";

import {faPencilAlt, faPlayCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import AppHeader from "~/component/common/AppHeader";
import CustomButton from "~/component/common/CustomButton";

// Adjust the import path as needed

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-screen min-h-screen overflow-auto relative text-white bg-transparent">
      <AppHeader title="Orbit Dash" />

      {/* Main Content Area */}
      <div className="flex flex-col items-center justify-center min-h-[80vh] px-2 py-2 mt-16 overflow-x-hidden">
        {/* Central Content */}
        <div className="relative z-10 max-w-5xl w-full mx-auto flex flex-col items-center">
          {/* Hero Section with Title */}
          <div className="text-center mb-4">
            <p
              className="text-2xl md:text-3xl font-light mb-8 max-w-2xl mx-auto"
              style={{textShadow: "0 0 4px rgba(0,0,0,0.9)"}}
            >
              Navigate the cosmos, create your path, become a legend
            </p>
          </div>

          {/* Main Navigation Buttons */}
          <div className="flex flex-wrap justify-center gap-8 mx-auto">
            <CustomButton
              onClick={() => navigate("/play")}
              className={`w-48 flex items-center justify-center bg-gradient-to-br from-blue-600 via-blue-500 to-black hover:from-blue-500 hover:via-blue-600 hover:to-black text-white text-lg md:text-2xl px-6 md:px-10 py-3 md:py-6 rounded-xl shadow-lg transform transition duration-300 hover:scale-105 hover:shadow-xl animate-bounce`}
              style={{
                animation: "pulse-scale 1.5s infinite",
                boxShadow: "0 0 15px rgba(59, 130, 246, 0.7)",
              }}
            >
              <FontAwesomeIcon
                icon={faPlayCircle}
                className={`mr-2 md:mr-4 animate-pulse`}
              />
              <span className="font-normal">PLAY</span>
            </CustomButton>

            <CustomButton
              onClick={() => navigate("/create")}
              className="w-48 flex items-center justify-center bg-gradient-to-br from-orange-500 via-orange-500 to-black hover:from-orange-400 hover:via-orange-500 hover:to-black text-white text-lg md:text-2xl px-6 md:px-10 py-3 md:py-6 rounded-xl shadow-lg transform transition duration-300 hover:scale-105 hover:shadow-xl"
            >
              <FontAwesomeIcon icon={faPencilAlt} className="mr-2 md:mr-4" />
              <span className="font-normal">CREATE</span>
            </CustomButton>
          </div>

          {/* Game Highlights */}
          <div className="mt-16 w-full grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-black bg-opacity-60 p-6 rounded-xl border border-white border-opacity-10 transform transition duration-300 hover:scale-105">
              <h3 className="text-xl font-normal mb-3 text-blue-500">
                CHALLENGE
              </h3>
              <p>
                Master increasingly difficult levels as you navigate through
                cosmic obstacles and traps.
              </p>
            </div>

            <div className="bg-black bg-opacity-60 p-6 rounded-xl border border-white border-opacity-10 transform transition duration-300 hover:scale-105">
              <h3 className="text-xl font-normal mb-3 text-orange-500">
                CREATE
              </h3>
              <p>
                Design your own levels with our intuitive level editor and share
                them with players worldwide.
              </p>
            </div>

            <div className="bg-black bg-opacity-60 p-6 rounded-xl border border-white border-opacity-10 transform transition duration-300 hover:scale-105">
              <h3 className="text-xl font-normal mb-3 text-[#C0C0C0]">
                COMPETE
              </h3>
              <p>
                Rise through the ranks on global leaderboards and establish
                yourself as an elite Orbit Dasher.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
